<template>
  <transition name="fade" mode="out-in">
    <div class="transition-page" :style="style">
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TransitionPage',
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    style() {
      return {
        paddingBottom: this.isMobile ? '60px' : undefined,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.transition-page {
  height: 100%;
  padding-bottom: 76px;
}

.fade-enter-active {
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-leave-active {
  transition: all 0.1s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
